import { render, staticRenderFns } from "./addRevisit.vue?vue&type=template&id=27169a52&scoped=true"
import script from "./addRevisit.vue?vue&type=script&lang=js"
export * from "./addRevisit.vue?vue&type=script&lang=js"
import style0 from "./addRevisit.vue?vue&type=style&index=0&id=27169a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27169a52",
  null
  
)

export default component.exports